import { createFileRoute, redirect } from '@tanstack/react-router'

import { FEATURE_DASHBOARD_COMPLETED } from '@/core/constants/features'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'
import UserProgressPageContent from '@/user-progress/components/UserProgressPageContent/UserProgressPageContent'

export const Route = createFileRoute('/_learning/_my-learning/user/progress')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-my-progress',
        }),
      },
    ],
  }),
  beforeLoad: ({ context: { user } }) => {
    if (!user?.features.includes(FEATURE_DASHBOARD_COMPLETED)) {
      throw redirect({ to: '/home' })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <UserProgressPageContent />
}
